<template>
  <WebChapterTemplate
    page-title="《新闻学传播学文摘》"
    section-label="传播与平台"
    section-route="/lanhu_chuanboyupingtai"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <section class="page-section">
      <article class="content-card">
        <h2 class="section-title">《新闻学传播学文摘》</h2>
        <p class="body-text">
          《新闻学传播学文摘》创办于 2014 年，是中国社会科学院新闻与传播研究所与中国社会科学出版社联合打造的学术文摘新品。它精选有代表性的年度新闻传播学科文章和学术观点，旨在襄助学科优质成果的扩散和彰显。
        </p>
        <figure class="book-gallery">
          <img :src="images.wenzhaiBooks" alt="《新闻学传播学文摘》书影" />
          <figcaption>《新闻学传播学文摘》书影</figcaption>
        </figure>
      </article>
    </section>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'NewLanhuXinwenxuechuanboxuewenzhai',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      images: {
        wenzhaiBooks: require('./assets/wenzhai-books.jpg')
      }
    };
  }
};
</script>

<style scoped>
.page-section {
  margin-bottom: 48px;
}

.page-section:last-child {
  margin-bottom: 0;
}

.content-card {
  padding: 28px;
  border-radius: 10px;
  background:
    linear-gradient(135deg, rgba(243, 247, 250, 0.82), rgba(255, 255, 255, 0) 45%),
    linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(252, 250, 246, 0.95));
  border: 1px solid rgba(179, 145, 101, 0.18);
}

.section-title {
  margin: 0 0 16px;
  color: #f25c19;
  font-size: 24px;
  line-height: 1.4;
  font-weight: 700;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.body-text {
  margin: 0 0 24px;
  color: #231f20;
  font-size: 15px;
  line-height: 1.9;
  text-align: justify;
  text-indent: 2em;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.book-gallery {
  margin: 0;
}

.book-gallery img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 10px 28px rgba(45, 33, 16, 0.08);
}

.book-gallery figcaption {
  margin-top: 10px;
  color: #6f6253;
  font-size: 12px;
  line-height: 1.6;
  text-align: center;
}

@media (max-width: 768px) {
  .content-card {
    padding: 18px;
  }
}
</style>
